import './index.scss';
import { useState, useEffect } from 'react';
import { useHistory } from 'react-router';
import { userInfo } from '../../../redux/slice';
import { useSelector } from 'react-redux';
import { get } from '../../../util/request';
import Loading from '../../../components/common/loading.js';
import { useTranslation } from 'react-i18next';

export default Questionnaires; function Questionnaires() {
    const history = useHistory();
    const user = useSelector(userInfo);
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();
    const currentDate = new Date();

    function goDetail(url, year, action) {
        history.push({
            pathname: url
        });
        sessionStorage.setItem('taxYear', year);
        sessionStorage.setItem('taxAction', action);
    }

    const [questionnaires, setQuestionnaires] = useState([]);

    const init = async () => {
        setLoading(true);
        const data = await get('/taxQuestionnaire/list', {
            accessToken: user.accessToken,
            userId: user.userId
        });
        if (data) {

            data?.map((stay, index) => {
                let currentYear = 0;
                let totalDaysLastYear = 0;
                let totalDaysLast2Years = 0;

                stay?.USStays?.map((item) => {
                    const year = getDaysPerYear(item.FromDate, item.ToDate);
                    currentYear = currentYear + (year[currentDate.getFullYear()] ?? 0);
                    totalDaysLastYear = totalDaysLastYear + (year[currentDate.getFullYear() - 1] ?? 0);
                    totalDaysLast2Years = totalDaysLast2Years + (year[currentDate.getFullYear() - 2] ?? 0);
                });

                data[index].PeriodStayedInUSTwoYearsAgo = totalDaysLast2Years;
                data[index].PeriodStayedInUSLastYear = totalDaysLastYear;
                data[index].PeriodStayedInUSCurrentYear = currentYear;
            });

            setQuestionnaires(data);
            setLoading(false);
        }
    }

    function getDaysPerYear(startDate, endDate) {
        const result = {};
        const start = new Date(startDate);
        const end = new Date(endDate);
        start.setHours(0, 0, 0, 0);
        end.setHours(0, 0, 0, 0);
        const endExclusive = new Date(end.getTime() + 24 * 60 * 60 * 1000);

        const startYear = start.getFullYear();
        const endYear = end.getFullYear();

        for (let year = startYear; year <= endYear; year++) {
            const yearStart = new Date(year, 0, 1);
            const yearEndExclusive = new Date(year + 1, 0, 1);
            const rangeStart = new Date(Math.max(start.getTime(), yearStart.getTime()));
            const rangeEnd = new Date(Math.min(endExclusive.getTime(), yearEndExclusive.getTime()));

            if (rangeEnd > rangeStart) {
                const days = (rangeEnd - rangeStart) / (24 * 60 * 60 * 1000);
                result[year] = days;
            }
        }
        return result;
    }

    const formatDate = (value) =>
        new Intl.DateTimeFormat('fr-CA', {
            year: 'numeric', month: '2-digit', day: '2-digit'

        }).format(value).replace(/-/g, '/');

    useEffect(() => {
        init();
    }, []);

    return (<>
        {
            user.sfUserType === 'CL' && (<>
                {loading && <Loading />}
                <div id='questionnaires'>
                    <div className='main-box questionnaire-div'>
                        <div className="headline tax-wrapper">
                            <div className={'tax-title'}><p>{t('Tax Questionnaires')}</p></div>
                        </div>

                        <div className='submit-box tax-container'>
                            <table>
                                <thead>
                                    <tr>
                                        <th>{t('Year')}</th>
                                        <th>{t('Due Date')}</th>
                                        <th>{t('Submission Date')}</th>
                                        <th>{t('Status')}</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        questionnaires?.map((questionnaire) => (<>
                                            <tr>
                                                <td>{questionnaire.TaxFilingYear}</td>
                                                <td>
                                                    {
                                                       questionnaire?.DueDate.includes('1900') ? '' : formatDate(new Date(questionnaire?.DueDate))
                                                    }
                                                </td>
                                                <td>
                                                    {
                                                        questionnaire?.SubmissionDate.includes('1900') ? '' : formatDate(new Date(questionnaire?.SubmissionDate))
                                                    }
                                                </td>
                                                <td>{t(questionnaire.Status)}</td>
                                                <td className='button-cell'>
                                                    {
                                                        !(questionnaire.CountryOfTaxResidency === 'USA' || questionnaire.OtherUSIncomeSource === 'Yes' || questionnaire.ActiveGreenCardHolder === 'Yes'
                                                            || (questionnaire.PeriodStayedInUSCurrentYear + (questionnaire.PeriodStayedInUSLastYear / 3) + (questionnaire.PeriodStayedInUSTwoYearsAgo / 6) > 183)) && (<>
                                                                <button onClick={(event) => {
                                                                    if (!user.accessToken) {
                                                                        event.preventDefault();
                                                                    } else {
                                                                        if (user.sfUserType === 'IR') {
                                                                            goDetail('/preview/taxQuestionnaire', questionnaire?.TaxFilingYear, 'View');
                                                                        }
                                                                        else {
                                                                            goDetail('/taxQuestionnaire', questionnaire?.TaxFilingYear, 'View');
                                                                        }
                                                                    }
                                                                }}
                                                                >{t('View')}</button>

                                                                {
                                                                    questionnaire.TotalTaxFilingFeeShortfall > 0 && (<>
                                                                        <button onClick={(event) => {
                                                                            if (!user.accessToken) {
                                                                                event.preventDefault();
                                                                            } else {
                                                                                if (user.sfUserType === 'IR') {
                                                                                    goDetail('/preview/taxQuestionnaire', questionnaire?.TaxFilingYear, 'Pay');
                                                                                }
                                                                                else {
                                                                                    goDetail('/taxQuestionnaire', questionnaire?.TaxFilingYear, 'Pay');
                                                                                }
                                                                            }
                                                                        }}
                                                                        >{t('Pay')}</button>
                                                                    </>)
                                                                }
                                                            </>)
                                                    }
                                                </td>

                                            </tr>
                                        </>))
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </>)
        }
    </>);
}